"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENVIRONMENT = exports.CONSENT_KEY = void 0;
var ENVIRONMENT = exports.ENVIRONMENT = /*#__PURE__*/function (ENVIRONMENT) {
  ENVIRONMENT["LOCAL"] = "local";
  ENVIRONMENT["DEV"] = "development";
  ENVIRONMENT["STAGING"] = "staging";
  ENVIRONMENT["PROD"] = "production";
  return ENVIRONMENT;
}({});
var CONSENT_KEY = exports.CONSENT_KEY = {
  COMMUNITY: 'communityTermsOfService',
  PRIVACY: 'privacyPolicy'
};